/* global mixpanel */
import formatDate from 'mixpanel/formatDate'
import moment from 'moment'

export function reportsTransactionsStart ({outletIds, startDate, endDate}) {
  mixpanel.track('Report Transactions Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate)
  })
}

export function reportsTransactionsChangeFilter ({outletIds, startDate, endDate}) {
  mixpanel.track('Report Transactions Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate)
  })
}

export function reportsTransactionsExport ({outletIds, startDate, endDate}) {
  mixpanel.track('Report Transactions Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate)
  })
}

export function reportsTransactionsSearchBarInit () {
  mixpanel.track('Report Transactions Search Bar Init')
}

export function reportsTransactionsSelect ({transactionDetail}) {
  mixpanel.track('Report Transactions Select', {
    'Transaction Date': moment(transactionDetail.created_at).format('YYYY-MM-DD'),
    'Transaction Time': moment(transactionDetail.created_at).format('hh:mm:ss'),
    'Receipt Number': transactionDetail.payment_no,
    'Served By': transactionDetail.served_by,
    'Collected By': transactionDetail.collected_by,
    'Total': transactionDetail.total_collected - transactionDetail.total_refund,
    'Payment Method': transactionDetail.payment_type,
    'Payment Amount': transactionDetail.payment_amount,
    'Payment Note': transactionDetail.payment_note
  })
}

export function reportsTransactionsResendReceipt () {
  mixpanel.track('Report Transactions Resend Receipt')
}

export function reportsTransactionRefund ({amount, isFullRefund, outletIds, startDate, endDate}) {
  mixpanel.track('Report Transactions Refund', {
    'Amount': amount,
    'Is Full Refund': isFullRefund,
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate)
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/reports/transactions.js